import { render, staticRenderFns } from "./ZonesIndex.vue?vue&type=template&id=e5e67970"
import script from "./ZonesIndex.vue?vue&type=script&lang=js"
export * from "./ZonesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports